import useTitle from "../../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import FinalGradesList from './FinalGradesList'
import { faPrint } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function FinalGradesListFilter({hidePrint}) {
    const {groupId} = useParams()
    const [q, setQ] = useState('')
    useTitle('geshtop-Exercise: FinalGrades List')


    const navigate = useNavigate()
    
   
    const content =(<>
    <div className="filter-form">
    <h2> גליון ציונים </h2>
        
                   
        <div className="filter-form-item">
            <input className="form__input" placeholder="חיפוש לפי שם או שם הקורס" onChange={(e)=>setQ(e.target.value)} />
            </div>
            <div className="filter-form-item">
           {!hidePrint &&   <button className="icon-button"  onClick={() => window.print()}><FontAwesomeIcon   icon={faPrint} />  </button>   }
</div>
    </div>
 <FinalGradesList q={q}  />
</> ) 
  return content;
}

export default FinalGradesListFilter